import CustomerInfoHtml          from '../../app-lite/customers/templates/customer.info.html';
import CustomerQuickAddHtml      from '../../app-lite/customers/templates/customer.quick-add.html';
import CustomerSearchResultsHtml from '../../app-lite/customers/templates/customers.search.results.html';

export function CustomerSelectionCtrl (
  $scope,
  $translate,
  companyApi,
  Customer,
  messages,
  sessionObjAPI,
  streamSearch,
  ukPostcodeApi,
  workshopAPI
) {
  $scope.boxContentTemplateUrl = $scope.customer.id ? CustomerInfoHtml : CustomerQuickAddHtml;

  $scope.Company = companyApi;
  $scope.customerApi = Customer;

  $scope.validateCompanyName = function ( name ) {
    return $scope.customerApi.validateCompanyName(name);
  };

  $scope.validateFirstAndLastName = function ( name, field = 'first_name', customer ) {
    return $scope.customerApi.validateFirstAndLastName(name, field, customer);
  };

  $scope.session = sessionObjAPI.base();

  $scope.search = {
    templateUrl: CustomerSearchResultsHtml,
    list: [],
    value: {
      id: $scope.customer.id
    },
    query: function (value) {
      return streamSearch.search('customers', value).then(function (response) {
        return $scope.search.list.concat(response);
      });
    },
    choose: function (customer) {
      $scope.onSelect({
        customer: customer
      });
    },
    format: function (value) {
      return value ? value.display_name: '';
    }
  };

  $scope.close = function () {
    $scope.$broadcast('close');
  };

  $scope.save = function (form) {
    // Flush any debounced view values (e.g. browser autofill on the wor-uniqueness-validator inputs) before proceeding.
    form.$commitViewValue();

    workshopAPI.post('/customers', $scope.customer, 'customer').then(function (customer) {
      form.$setPristine();

      $scope.onSelect({
        customer: customer
      });
    }).catch(function (err) {
      messages.error(err);
    });
  };

  $scope.searchUKPostcode = function () {
    ukPostcodeApi.search($scope.customer.postcode)
    .then(data => {
      $scope.customer.address1 = data.Premises;
      $scope.customer.address2 = data.Street;
      $scope.customer.suburb   = data.PostTown;
      $scope.customer.postcode = data.Postcode;

      messages.show($translate.instant('CUSTOMER_SPACE.CUSTOMER_ADDRESS_UPDATED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  workshopAPI.get('/system/state_types', null, 'states').then(function (states) {
    $scope.unitedStates = states;
  });

  workshopAPI.get('/system/preferred_contact_method_types', null, 'contactMethods').then(function (contacts) {
    $scope.contact_method_types = contacts;
  });

  workshopAPI.get('/customer_sources', null, 'customerSources').then(function (sources) {
    $scope.customerSources = sources;
  });

  workshopAPI.get('/system/customer_price_types', null, 'customerPriceTypes').then(function (priceTypes) {
    $scope.price_types = priceTypes;
  });
}
